import styled from '@emotion/styled';

import PaymentTable from 'components/ui/PaymentTable';

const Elem:React.FC<any> = () => {

  const payList = [
    {},
    {},
    {},
    {},

  ]
  return (
    <Container>
      {payList.map((index)=> (
        <PaymentTable></PaymentTable>
      ))}
    </Container>
  )
}

export default Elem;

const Container = styled.div`
  width: 430px;
  display: flex;
  flex-direction: column;
`
